import { abrirImpressao, escaparHtml } from '@/comuns/impressao';
import { dataSimples, moeda } from '@/comuns/formato';
import type { Orcamento } from '@/data/tipos';

/**
 * A proposta em papel — ou em PDF pela janela de impressão.
 *
 * Sai dos ITENS gravados, não do resumo da listagem: é o mesmo número que a
 * paciente vai conferir. Rascunho sai marcado como rascunho.
 */
export function imprimirOrcamento(o: Orcamento, clinica: string): boolean {
    const linhas = o.itens.map((i) => '<tr>'
        + `<td>${escaparHtml(i.descricao)}</td>`
        + `<td class="n">${i.quantidade}</td>`
        + `<td class="n">${escaparHtml(moeda(i.valorUnitarioCentavos))}</td>`
        + `<td class="n">${i.descontoCentavos ? escaparHtml(moeda(i.descontoCentavos)) : '—'}</td>`
        + `<td class="n">${escaparHtml(moeda(Math.max(0, i.quantidade * i.valorUnitarioCentavos - i.descontoCentavos)))}</td>`
        + '</tr>').join('');

    return abrirImpressao({
        titulo: `Proposta ${o.numero}`,
        estilo: 'h1{font-family:var(--font-display);font-size:22px;margin:4px 0;letter-spacing:-.02em}'
            + 'p.sub{margin:0 0 4px;font-size:12px;color:var(--text-secondary)}'
            + 'p.aviso{margin:12px 0 0;padding:8px 10px;border:1px solid var(--border-strong);border-radius:8px;font-size:12px}'
            + 'table{width:100%;border-collapse:collapse;font-size:12px;margin-top:18px}'
            + 'th{text-align:left;font-size:10px;text-transform:uppercase;letter-spacing:.04em;color:var(--text-secondary);border-bottom:1px solid var(--border-strong);padding:7px 8px}'
            + 'td{padding:8px;border-bottom:1px solid var(--border-subtle)}'
            + 'td.n,th.n{text-align:right;font-variant-numeric:tabular-nums}'
            + 'p.total{margin:16px 0 0;text-align:right;font-size:16px;font-weight:700;font-variant-numeric:tabular-nums}',
        corpo: `<p class="sub">${escaparHtml(clinica)}</p>`
            + `<h1>Proposta ${escaparHtml(o.numero)}</h1>`
            + `<p class="sub">${escaparHtml(o.paciente)} · responsável ${escaparHtml(o.responsavel)}</p>`
            + `<p class="sub">Emitida em ${escaparHtml(dataSimples(o.criadoEm))}${o.validade ? ` · válida até ${escaparHtml(dataSimples(o.validade))}` : ''}</p>`
            + (o.status === 'rascunho' ? '<p class="aviso">Rascunho — esta proposta ainda não foi enviada.</p>' : '')
            + '<table><thead><tr><th>Item</th><th class="n">Qtd</th><th class="n">Valor unit.</th><th class="n">Desconto</th><th class="n">Total</th></tr></thead>'
            + `<tbody>${linhas}</tbody></table>`
            + `<p class="total">Total ${escaparHtml(moeda(o.totalCentavos))}</p>`,
    });
}
